function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M20.992 18.321a.964.964 0 01-.964.964h-3.213a.964.964 0 01-.963-.964v-3.213a.964.964 0 01.963-.963h.964v-1.928h-5.14v1.928h.964a.964.964 0 01.963.963v3.213a.964.964 0 01-.963.964H10.39a.964.964 0 01-.964-.964v-3.213a.964.964 0 01.964-.963h.964v-1.928H6.213v1.928h.964a.964.964 0 01.964.963v3.213a.964.964 0 01-.964.964H3.964A.964.964 0 013 18.321v-3.213a.964.964 0 01.964-.963h.964v-1.928a1.294 1.294 0 011.285-1.285h5.14V9.004h-.963a.964.964 0 01-.964-.964V4.827a.964.964 0 01.964-.964h3.213a.964.964 0 01.963.964V8.04a.964.964 0 01-.963.964h-.964v1.928h5.14a1.294 1.294 0 011.285 1.285v1.927h.964a.964.964 0 01.964.964z"
});

function SvgSpMenuLoadBalancers(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 24 24"
  }, props), _ref);
}

export default __webpack_public_path__ + "spMenuLoadBalancers.337ef.svg";
export { SvgSpMenuLoadBalancers as ReactComponent };